"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var styled_components_1 = require("styled-components");
var react_intl_1 = require("react-intl");
var Icon_1 = __importDefault(require("../../Icon"));
var styles_1 = require("./styles");
var SidebarHeader = function (_a) {
    var handleCloseSidebar = _a.handleCloseSidebar, logoPath = _a.logoPath, messages = _a.messages;
    var name = (0, styled_components_1.useTheme)().name;
    var formatMessage = (0, react_intl_1.useIntl)().formatMessage;
    return ((0, jsx_runtime_1.jsxs)(styles_1.Container, { children: [(0, jsx_runtime_1.jsxs)(styles_1.LogosContainer, __assign({ to: logoPath, "aria-label": logoPath, tabIndex: -1 }, { children: [name !== 'agco' && (0, jsx_runtime_1.jsx)(styles_1.ClosedLogo, { variant: "secondary", testId: "sidebar-logo-".concat(name) }), (0, jsx_runtime_1.jsx)(styles_1.ExpandedLogo, {})] })), (0, jsx_runtime_1.jsx)(styles_1.CloserContainer, __assign({ onClick: handleCloseSidebar, "aria-label": (messages === null || messages === void 0 ? void 0 : messages.collapseSidebar) ? formatMessage(messages.collapseSidebar) : 'Collapse sidebar' }, { children: (0, jsx_runtime_1.jsx)(styles_1.CloserIcon, { children: (0, jsx_runtime_1.jsx)(Icon_1.default, { name: "chevron-double-left" }) }) }))] }));
};
exports.default = SidebarHeader;
